import React from 'react'
import Alert from 'react-s-alert';
import { withTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import './Login.scss'
const LoginForm = ({ account, children, logo, target, handleSubmitLogin, handleChange, t }) => {
    return (
        <div className='loginContainer'>
            <div className='loginContent'>
                <img className='loginLogo' src={logo} alt='Zaddons Logo' />
                <div className='loginFormContainer'>
                    <p className="text-center pv">{t('Login.title')}</p>
                    <form data-parsley-validate="" onSubmit={handleSubmitLogin} noValidate className="mb-lg">
                        <div className="form-group has-feedback">
                            <label htmlFor='username'>{t('Login.username')}</label>
                            <input
                                id="username"
                                name="username"
                                type="text"
                                placeholder={t('Login.username')}
                                autoComplete="off"
                                onChange={handleChange}
                                required="required"
                                className="form-control"
                                value={account.username} />
                        </div>
                        <div className="form-group has-feedback">
                            <label htmlFor='password'>{t('Login.password')}</label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                placeholder={t('Login.password')}
                                onChange={handleChange}
                                required="required"
                                className="form-control"
                                value={account.password} />
                        </div>
                        <Button
                            disabled={!target === ''}
                            type="submit"
                            className={`buttonSubmit`}
                        >
                            {t('Login.login')}
                        </Button>
                    </form>
                </div>
                <span>
                    {children}
                </span>
                <Alert stack={{ limit: 3 }} />
                <span className='copyRights'>{t('Login.copyRights')}</span>
            </div>
        </div>
    );
}
export default withTranslation('common')(LoginForm);
